module.exports = __webpack_public_path__ + "img/e.65422660.jpg";